import { HubUserAttributesClient } from 'frontend-preferences-client';
import { rethrowError } from 'UIComponents/core/PromiseHandlers';
const hubUserAttributesClient = HubUserAttributesClient.forCaller('accounting-integrations-ui-components');
export function writeHubUserAttribute(name, value) {
  hubUserAttributesClient.write(name, value).catch(rethrowError);
}
export function getHubUserAttribute(name, defaultValue) {
  return hubUserAttributesClient.fetch(name, defaultValue).catch(rethrowError);
}